const title = process.env.VUE_APP_TITLE
const getTitle = function(til) {
  let allTitle = til
  if (allTitle === '集团公司总部体检管理') {
    return allTitle
  } else {
    return til + ' - ' + title
  }
}
export default getTitle
